var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4785 23.3516H12.168V20.0408L15.9432 16.2656C15.9265 16.1282 15.9181 15.9899 15.918 15.8516C15.9175 15.0921 16.1476 14.3504 16.5779 13.7246C17.0082 13.0988 17.6184 12.6184 18.3277 12.3469C19.037 12.0755 19.812 12.0258 20.5501 12.2045C21.2882 12.3831 21.9548 12.7817 22.4614 13.3474C22.9681 13.9132 23.2911 14.6194 23.3876 15.3727C23.4841 16.126 23.3496 16.8909 23.0019 17.5661C22.6542 18.2412 22.1097 18.795 21.4404 19.1539C20.7711 19.5129 20.0086 19.6602 19.2538 19.5763L15.4785 23.3516ZM13.668 21.8516H14.8574L18.762 17.9468L19.1666 18.0397C19.6488 18.1546 20.1553 18.1089 20.6091 17.9097C21.063 17.7104 21.4394 17.3685 21.6812 16.9358C21.923 16.5031 22.017 16.0034 21.9489 15.5124C21.8807 15.0214 21.6542 14.5661 21.3037 14.2157C20.9532 13.8652 20.4979 13.6387 20.0069 13.5706C19.5159 13.5025 19.0161 13.5965 18.5835 13.8384C18.1508 14.0802 17.8089 14.4567 17.6097 14.9105C17.4105 15.3644 17.3649 15.8709 17.4798 16.3531L17.5725 16.7576L13.668 20.6623V21.8516Z",
    fill: "#0F1011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.668 16.6016C20.0822 16.6016 20.418 16.2658 20.418 15.8516C20.418 15.4373 20.0822 15.1016 19.668 15.1016C19.2538 15.1016 18.918 15.4373 18.918 15.8516C18.918 16.2658 19.2538 16.6016 19.668 16.6016Z",
    fill: "#0F1011"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.918 5.35156H6.91797V6.85156H15.918V5.35156Z",
    fill: "#0F1011"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.918 8.35156H6.91797V9.85156H15.918V8.35156Z",
    fill: "#0F1011"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.418 11.3516H6.91797V12.8516H11.418V11.3516Z",
    fill: "#0F1011"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 18.8516H6.91797V20.3516H9.91797V18.8516Z",
    fill: "#0F1011"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 23.3516H5.41797C5.02027 23.3511 4.63898 23.193 4.35777 22.9118C4.07655 22.6305 3.91839 22.2493 3.91797 21.8516V3.85156C3.91839 3.45387 4.07655 3.07258 4.35777 2.79136C4.63898 2.51015 5.02027 2.35198 5.41797 2.35156H17.418C17.8157 2.35198 18.197 2.51015 18.4782 2.79136C18.7594 3.07258 18.9176 3.45387 18.918 3.85156V10.6016H17.418V3.85156H5.41797V21.8516H9.91797V23.3516Z",
    fill: "#0F1011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocIcon);
export default __webpack_public_path__ + "static/media/file-doc-icon.d8c94ab4aa91c5dee61e73074d63db29.svg";
export { ForwardRef as ReactComponent };